
CheckoutV2.Login.Lookup = function(checkout, login) {
	var lookup = this;

	this.request = false;

	this.$wrap = $('.js-login-lookup');
	this.$loading = $('.js-login-lookup-overlay');
	this.$error = $('.js-login-lookup-error');
	this.$errorMsg = this.$error.find('.msg-text');

	this.$search = $('.js-login-lookup-search');
	this.$resultWrap = $('.js-login-lookup-result-wrap');
	this.$resultContainer = $('.js-login-lookup-result-container');

	this.init = function() {
		if (checkout.user) {
			lookup.listen();
			lookup.$wrap.show();
		}
	};

	this.listen = function() {

		lookup.$search.bind('input propertychange', function() {

			if (lookup.request)
				lookup.request.abort();

			checkout.delayChange(lookup.$search, 1000, function() {
				lookup.search();
			});

		});

	};
	
	this.listenSelectCustomer = function() {
		lookup.$resultContainer.find('button').click(function() {
			lookup.selectResult($(this).parents('.login-lookup-result').first());
		});
	}

	this.search = function() {
		var query = lookup.$search.val();

		lookup.$resultWrap.hide();
		lookup.$resultContainer.empty();

		if (query.length < 4)
			return;

		lookup.$resultWrap.show();

		lookup.error(false);
		lookup.loading(true);

		lookup.request = checkout.remote.call({
			'data': {
				'step': 'billship',
				'action': 'lookup',
				'query': query
			}
		})
		.done(function(response) {
			lookup.showResults(response.data);
		})
		.fail(function(request) {
			lookup.error((checkout.remote.getErrorMsg(request) || 'Customer Lookup Failed'));
			lookup.$resultWrap.hide();
		})
		.always(function() {
			lookup.loading(false);
		});
	};

	this.showResults = function(results) {
		lookup.$resultContainer.html(
			Jemplate.process('includes/partials/login-lookup-results.html', {
				data: results,
			})
		);
		lookup.listenSelectCustomer();
	};

	this.selectResult = function($result) {
		var customerID = $result.attr('data-customer-id');

		login.login.loading('Logging In');

		return checkout.remote.call({
			'data': {
				'step': 'billship',
				'action': 'loginByCustomerID',
				'customerID': customerID
			}
		})
			.done(function(response) {

				login.login.$headerLogin.replaceWith(
					'<li class="logout"><a href="/MyAccount/Logout/" title="Logout">Logout</a></li>'
				);

				checkout.session.load(response.data);
				if (response.data.refreshCart) {
					checkout.cart.checkItems(true, true);
				} else {
					checkout.cart.checkItems();
				}
				login.proceed();
				if (response.data.shipping) { // update shipping after logging in as customer
					if (response.data.shipping.country) {
						checkout.cart.shipping.$country.val(response.data.shipping.country);
					}
					if (response.data.shipping.zip) {
						checkout.cart.shipping.$zip.val(response.data.shipping.zip);
						checkout.cart.shipping.zip = response.data.shipping.zip;
					}
					if (response.data.shipping.country || response.data.shipping.zip) {
						checkout.cart.shipping.calc(false, true);
					}
				}
			})
			.fail(function(request) {
				lookup.error('Failed to Login As Selected Customer');
			})
			.always(function() {
				login.login.loading(false);
			});
	};

	this.loading = function(show) {
		if (show) {
			lookup.$loading.show();
			checkout.alignMiddle(lookup.$loading.find('.msg'), lookup.$loading);
		} else
			lookup.$loading.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var currentMsg = lookup.$errorMsg.html();

			if (currentMsg)
				lookup.$errorMsg.html(currentMsg + '<br />' + errorMsg);
			else
				lookup.$errorMsg.html(errorMsg);

			lookup.$error.show();
		} else {
			lookup.$error.hide();
			lookup.$errorMsg.html('');
		}
	};

	this.init();
};

